import React from 'react';

const CallbackConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: '/callback',
      component: React.lazy(() => import('./Callback')),
    },
  ],
};

export default CallbackConfig;
